<template>
  <div id="shop-product-list">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex :key="index" v-for="(item, index) in states" xs6>
          <v-card
            class="card-shop-product"
            @click="onClickCard(item.idx)"
            color="white"
            elevation="0"
          >
            <v-img
              aspect-ratio="1"
              contain
              :lazy-src="require('@/assets/NoPicture.png')"
              :src="mapProductPicture(item.productId)"
            ></v-img>
            <v-card-text class="pt-0">
              <div class="title">{{ mapProductName(item.productId, 'TH') }}</div>
              <div class="subheading spacing-2">{{ mapProductName(item.productId, 'EN') }}</div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'shop-product-list',
  props: {
    shopEditionId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      states: [],
      currentMonth: new Date().getMonth()
    }
  },
  computed: {
    products() {
      return this.$store.state.Product.nameProducts
    }
  },
  created() {
    if (this.$store.state.Product.nameProducts.length === 0)
      this.$store.dispatch('Product/fetchProductName')
  },
  mounted() {
    this.fethData()
  },
  methods: {
    onClickCard(idx) {
      this.$router.push({
        name: 'shop-product-detail',
        params: { shopEditionProductId: btoa(idx) }
      })
    },
    mapProductName(productId, lang) {
      switch (lang) {
        case 'EN':
          return this.products
            .filter(item => item.productid === productId)
            .map(item => item.productnameeng)[0]

        default:
          return this.products
            .filter(item => item.productid === productId)
            .map(item => item.productname)[0]
      }
    },
    mapProductPicture(productId) {
      return this.products
        .filter(item => item.productid === productId)
        .map(item => item.mainpictureurl)[0]
    },
    async fethData() {
      try {
        const response = await this.axios.get(`farmerspace/shop/product`)
        this.states = response.data.filter(item => item.shopEditionId == this.shopEditionId)
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-shop-product {
  border-radius: 0px;
}
</style>
